import { render, staticRenderFns } from "./LearningRecordHeader.vue?vue&type=template&id=2db8b23c&scoped=true"
import script from "./LearningRecordHeader.vue?vue&type=script&lang=js"
export * from "./LearningRecordHeader.vue?vue&type=script&lang=js"
import style0 from "./LearningRecordHeader.vue?vue&type=style&index=0&id=2db8b23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db8b23c",
  null
  
)

export default component.exports